import type { OfferFormData } from '../types/offer.types';

interface ValidationError {
  field: string;
  message: string;
}

export function useOfferValidation() {
  function validateOffer(data: OfferFormData): ValidationError[] {
    const errors: ValidationError[] = [];

    if (!data.name?.trim()) {
      errors.push({ field: 'name', message: 'Nazwa jest wymagana' });
    }

    if (!data.category_id) {
      errors.push({ field: 'category_id', message: 'Kategoria jest wymagana' });
    }

    if (data.price && !isValidPrice(data.price)) {
      errors.push({ field: 'price', message: 'Nieprawidłowy format ceny' });
    }

    return errors;
  }

  function isValidPrice(price: string): boolean {
    const priceRegex = /^\d+([.,]\d{1,2})?$/;
    return priceRegex.test(price.trim());
  }

  function hasValidationErrors(data: OfferFormData): boolean {
    return validateOffer(data).length > 0;
  }

  function getFirstError(data: OfferFormData): string | null {
    const errors = validateOffer(data);
    return errors.length > 0 ? errors[0].message : null;
  }

  return {
    validateOffer,
    hasValidationErrors,
    getFirstError,
    isValidPrice,
  };
}